(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hai-product-recommendations')) {
    // 负责加载 Shopify 推荐结果，并在当前区块内创建独立的 Swiper 实例。
    class HaiProductRecommendations extends HTMLElement {
      async connectedCallback() {
        const url = this.dataset.url;

        if (this.querySelector('.hai-product-recommendations__item')) {
          this.dataset.loaded = 'true';
          this.setAttribute('aria-busy', 'false');
          this.initializeSwiper();
          return;
        }

        if (!url) {
          this.hideSection();
          return;
        }

        if (this.dataset.loaded === 'true') return;

        this.dataset.loaded = 'true';

        try {
          // 正式店铺必须通过推荐接口读取 Shopify Search & Discovery 中手工选择的商品。
          const response = await fetch(url);

          if (!response.ok) {
            throw new Error(`Product recommendations request failed: ${response.status}`);
          }

          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const recommendationsContent = documentFragment.querySelector('[data-product-recommendations]');
          const hasRecommendations = recommendationsContent?.querySelector('.hai-product-recommendations__item');

          // 推荐接口返回空结果时移除整个区块，不向消费者暴露内部空状态。
          if (!hasRecommendations) {
            this.hideSection();
            return;
          }

          // 一次性替换骨架屏，避免标题、控件或商品网格出现不同步状态。
          this.innerHTML = recommendationsContent.innerHTML;
          this.setAttribute('aria-busy', 'false');
          this.initializeSwiper();
        } catch (error) {
          console.error(error);
          // 请求失败时同样隐藏整个推荐区域，避免骨架屏永久停留。
          this.hideSection();
        }
      }

      hideSection() {
        this.setAttribute('aria-busy', 'false');

        const sectionWrapper = this.closest('.shopify-section');

        if (sectionWrapper) {
          sectionWrapper.hidden = true;
          return;
        }

        this.hidden = true;
      }

      initializeSwiper(retryCount = 0) {
        const slider = this.querySelector('[data-product-recommendations-swiper]');

        if (!slider || slider.swiper || !slider.querySelector('.swiper-slide')) return;

        if (!window.Swiper) {
          // Swiper 在主题中使用 defer 加载，等待全局脚本就绪后再初始化。
          if (retryCount < 20 && this.isConnected) {
            this.swiperRetryTimer = window.setTimeout(() => this.initializeSwiper(retryCount + 1), 120);
          }
          return;
        }

        const controls = this.querySelector('[data-product-recommendations-controls]');
        const scrollbar = this.querySelector('[data-product-recommendations-scrollbar]');

        this.swiper = new window.Swiper(slider, {
          slidesPerView: 1.15,
          spaceBetween: 16,
          grabCursor: true,
          watchOverflow: true,
          speed: 500,
          observer: true,
          observeParents: true,
          navigation: {
            prevEl: this.querySelector('[data-product-recommendations-prev]'),
            nextEl: this.querySelector('[data-product-recommendations-next]')
          },
          scrollbar: {
            el: scrollbar,
            draggable: true
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true
          },
          on: {
            // 商品数量不超过当前断点的可见数量时，不展示无效的切换控件。
            init: (swiper) => this.updateControls(swiper, controls, scrollbar),
            lock: (swiper) => this.updateControls(swiper, controls, scrollbar),
            unlock: (swiper) => this.updateControls(swiper, controls, scrollbar),
            resize: (swiper) => this.updateControls(swiper, controls, scrollbar)
          },
          breakpoints: {
            750: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 24
            }
          }
        });
      }

      updateControls(swiper, controls, scrollbar) {
        const hasOverflow = !swiper.isLocked;

        if (controls) controls.hidden = !hasOverflow;
        if (scrollbar) scrollbar.hidden = !hasOverflow;
      }

      disconnectedCallback() {
        window.clearTimeout(this.swiperRetryTimer);

        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }
    }

    customElements.define('hai-product-recommendations', HaiProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videobg-txt"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '[data-video-bg-section]';

    const viewportKind = () => {
      if (window.innerWidth <= 767) return 'mobile';
      if (window.innerWidth <= 1023) return 'tablet';
      return 'desktop';
    };

    const loadSources = (video) => {
      if (!video || video.dataset.sourcesLoaded === 'true') return;
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.dataset.sourcesLoaded = 'true';
      video.load();
    };

    const playVideo = (video, onRejected) => {
      const result = video.play();
      if (result && typeof result.catch === 'function') result.catch(onRejected);
    };

    const initSection = (section) => {
      if (section.dataset.videoBgInitialized === 'true') return;
      section.dataset.videoBgInitialized = 'true';

      const blocks = section.querySelector('.main-video-blocks');
      const stage = section.querySelector('[data-video-stage]');
      const posterHost = section.querySelector('[data-video-poster-host]');
      const playButton = section.querySelector('[data-video-play]');
      const backgroundVideos = Array.from(section.querySelectorAll('[data-background-video]'));
      const accordionTrigger = section.querySelector('[data-video-accordion-trigger]');
      const accordionButton = section.querySelector('.video-accordian-button');
      const leftVideo = section.querySelector('[data-left-video]');

      if (!blocks || !stage || !posterHost || !playButton || backgroundVideos.length === 0) return;

      let activeVideo;
      let isVisible = false;
      let userStarted = false;
      let resizeTimer;

      const videoForViewport = () => {
        const desiredKind = viewportKind();
        return backgroundVideos.find((video) => video.dataset.videoKind === desiredKind)
          || backgroundVideos.find((video) => video.dataset.videoKind === 'desktop')
          || backgroundVideos[0];
      };

      const showFallback = () => {
        stage.classList.remove('is-poster-loading', 'is-video-loading', 'is-video-playing');
        stage.classList.add('is-play-fallback');
      };

      // 视频已具备可展示画面时立即结束加载状态，避免浏览器遗漏 playing 事件后加载条常驻。
      const markVideoReady = (video) => {
        if (video !== activeVideo) return;
        stage.classList.remove('is-poster-loading', 'is-video-loading', 'has-poster-ready', 'is-play-fallback');
        stage.classList.add('is-video-playing');
        posterHost.replaceChildren();
        delete posterHost.dataset.videoKind;
      };

      const bindVideoEvents = (video) => {
        if (video.dataset.eventsBound === 'true') return;
        video.dataset.eventsBound = 'true';

        video.addEventListener('playing', () => markVideoReady(video));

        video.addEventListener('canplay', () => {
          if (!video.paused) markVideoReady(video);
        });

        video.addEventListener('timeupdate', () => {
          if (!video.paused && video.currentTime > 0) markVideoReady(video);
        });

        // 只有正在播放的视频进入缓冲时才显示加载条，暂停或离开视口后不保留加载状态。
        const markVideoBuffering = () => {
          if (video !== activeVideo || video.paused) return;
          stage.classList.remove('is-video-playing');
          stage.classList.add('is-video-loading');
        };

        video.addEventListener('waiting', markVideoBuffering);
        video.addEventListener('stalled', markVideoBuffering);

        video.addEventListener('pause', () => {
          if (video === activeVideo) stage.classList.remove('is-video-loading');
        });

        video.addEventListener('error', () => {
          if (video === activeVideo) showFallback();
        });
      };

      const selectActiveVideo = () => {
        const nextVideo = videoForViewport();
        if (activeVideo === nextVideo) return false;
        if (activeVideo) {
          activeVideo.pause();
          activeVideo.classList.remove('is-active-bg-video');
        }
        activeVideo = nextVideo;
        activeVideo.classList.add('is-active-bg-video');
        bindVideoEvents(activeVideo);
        posterHost.replaceChildren();
        delete posterHost.dataset.videoKind;
        stage.classList.remove('is-poster-loading', 'is-video-loading', 'is-video-playing', 'has-poster-ready', 'is-play-fallback');
        return true;
      };

      const startActiveVideo = () => {
        if (!activeVideo) selectActiveVideo();
        if (!activeVideo) return;
        stage.classList.remove('is-poster-loading', 'has-poster-ready', 'is-play-fallback');
        stage.classList.add('is-video-loading');
        loadSources(activeVideo);
        playVideo(activeVideo, showFallback);
      };

      const loadPoster = () => {
        if (!activeVideo) selectActiveVideo();
        if (!activeVideo) return;
        const videoKind = activeVideo.dataset.videoKind;
        const template = section.querySelector(`[data-video-poster-template][data-video-kind="${videoKind}"]`);
        if (!template) {
          startActiveVideo();
          return;
        }
        if (posterHost.dataset.videoKind === videoKind && posterHost.childElementCount > 0) return;

        posterHost.replaceChildren(template.content.cloneNode(true));
        posterHost.dataset.videoKind = videoKind;
        stage.classList.remove('has-poster-ready', 'is-play-fallback', 'is-video-playing');
        stage.classList.add('is-poster-loading');

        const image = posterHost.querySelector('.video-bg-poster-image');
        const posterReady = () => {
          stage.classList.remove('is-poster-loading');
          stage.classList.add('has-poster-ready');
        };
        const posterFailed = () => {
          posterHost.replaceChildren();
          delete posterHost.dataset.videoKind;
          startActiveVideo();
        };

        if (!image) {
          posterFailed();
          return;
        }
        image.addEventListener('load', posterReady, { once: true });
        image.addEventListener('error', posterFailed, { once: true });
        if (image.complete) {
          if (image.naturalWidth > 0) posterReady();
          else posterFailed();
        }
      };

      const prepareVisibleMedia = () => {
        selectActiveVideo();
        if (userStarted || activeVideo.dataset.hasPoster !== 'true') startActiveVideo();
        else loadPoster();
      };

      playButton.addEventListener('click', () => {
        userStarted = true;
        selectActiveVideo();
        startActiveVideo();
      });

      if (accordionTrigger) {
        const toggleAccordion = () => {
          const expanded = blocks.classList.toggle('active');
          if (accordionButton) accordionButton.setAttribute('aria-expanded', String(expanded));
          if (!leftVideo) return;
          if (expanded && window.innerWidth >= 1024) {
            loadSources(leftVideo);
            playVideo(leftVideo, () => undefined);
          } else {
            leftVideo.pause();
          }
        };

        accordionTrigger.addEventListener('click', toggleAccordion);
      }

      const observer = new IntersectionObserver((entries) => {
        isVisible = entries[0].isIntersecting;
        if (isVisible) prepareVisibleMedia();
        else if (activeVideo && !activeVideo.paused) activeVideo.pause();
      }, { threshold: 0.05 });

      observer.observe(section);

      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => {
          const changed = selectActiveVideo();
          if (changed && isVisible) prepareVisibleMedia();
        }, 150);
      });
    };

    const initAll = (root = document) => {
      if (root.matches && root.matches(sectionSelector)) initSection(root);
      root.querySelectorAll(sectionSelector).forEach(initSection);
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
    else initAll();

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
